import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Form, Row, Button, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { stateListAPI } from 'actions/StateMaster/stateMasterAction';
import { countryListAPI } from 'actions/CountryMaster/countryMasterAction';
import { caseListReportDataAction, generateCaseListReportPdfAPI } from 'actions/ClientDairy/caseListReportAction';
import loader from '../../assets/img/loader.svg'

export const ClientCaseListReportDetail = () => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);
	const [countryList, setCountryList] = useState([]);
	const [stateList, setStateList] = useState([]);
	const [pageSize, setPageSize] = useState(5);
	let token = localStorage.getItem('Token') || sessionStorage.getItem('Token');
	const headers = {
		Authorization: `Bearer ${JSON.parse(token).value}`
	};

	const caseListReportReducer = useSelector((state) => state.rootReducer.caseListReportReducer)
	var caseListReportData = caseListReportReducer.caseListReportData;

	useEffect(() => {
		getCountries();
	}, [])

	
	useEffect(() => {
			  setTimeout(() => {
				setIsLoading(false);
			  }, 1000);
	}, [isLoading])
	const GenerateCaseListReportPDF = async () => {
			let requestData = {
				CaseStatus:caseListReportData.caseStatus ? caseListReportData.caseStatus : "",
				EncryptedAdvocateCode: localStorage.getItem('EncryptedAdvocateCode'),
				ReportType: caseListReportData.reportType ? caseListReportData.reportType : "CN",
				stateCode: caseListReportData.stateCode ? caseListReportData.stateCode : "",
			}
			setIsLoading(true);
			await dispatch(
				generateCaseListReportPdfAPI(
					requestData,
					(res) => {
						
						setIsLoading(false);
						console.log(res);
					},
					(err) => {
					    setIsLoading(false);
						toast.error("No records found!", {
							theme: 'colored',
							autoClose: 10000
						});
						console.error("Error occurred while generating PDF:", err?.message || err);
					},
					headers
				)
			);
	}

	const getCountries = async (page, size = pageSize) => {
		const data = {
			pageNumber: page,
			pageSize: size,
			SearchText: '',
			isDropDown: true,
		};
		await dispatch(countryListAPI(
			data,
			(res) => {
				let countryData = [];
				if (res.data.data.countryList.length > 0)
					res.data.data.countryList.forEach(country => {
						countryData.push({
							key: country.countryName,
							value: country.countryCode
						});
					});
				setCountryList(countryData);
			},
			(err) => {
				toast.error(err?.data?.message || "Error fetching countries", {
					theme: 'colored',
					autoClose: 10000,
				});
				setCountryList([]);
			}
			, headers
		));
	};

	const getStates = async (selectCountryCode) => {
		const data = {
			countryCode: selectCountryCode,
			isDropDown: true,
			isList: false
		}
		await dispatch(stateListAPI(
			data,
			(res) => {

				let stateData = [];
				if (res && res.length > 0) {
					res.forEach(state => {
						stateData.push({
							key: state.stateName,
							value: state.stateCode
						});
					});
					setStateList(stateData);
				} else {
					setStateList([]);
				}
			},
			(err) => {
				setStateList([]);
			}
		));
	};

	const handleFieldChange = (e) => {
		dispatch(
			caseListReportDataAction({
				...caseListReportData,
				[e.target.name]: e.target.value,
			})
		);
		if (e.target.name == "countryCode") {
			if (e.target.value == '')
				setStateList([]);
			else
				getStates(e.target.value);
		}
	};

	return (
		<>
			{/* {isLoading ? (
				<Spinner
			  className="loader-color popup-loader position-fixed top-50 start-50 translate-middle z-index-5"
          // className="position-absolute start-50 loader-color"
					animation="border"
				/>
			) : null} */}
			      {isLoading ? (
  <img
    src={loader}
    alt="Loading..."
    className="loader-gif position-fixed top-50 start-50 translate-middle z-index-5"
  />
) : null}
			<Form className="details-form cash-Collection-Report">
				<Row className='justify-content-left ms-2 casSchedule-button '>
					<Form.Label column className='col-auto form-label-name'>
						Country
					</Form.Label>
					<Col className='col-auto client-list-filter case-list-filter'>
						<Form.Select id="txtCountry" name="countryCode"
							onChange={handleFieldChange}
							required>
							<option value=''>Select country</option>
							{countryList.map((option, index) => (
								<option key={index} value={option.value}>{option.key}</option>
							))}
						</Form.Select>
					</Col>
					<Form.Label column className='col-auto'>
						State
					</Form.Label>
					<Col className='col-auto client-list-filter case-list-filter'>
						<Form.Select id="txtState" name="stateCode"
							onChange={handleFieldChange}
							required>
							<option value=''>Select state</option>
							{stateList.map((option, index) => (
								<option key={index} value={option.value}>{option.key}</option>
							))}
						</Form.Select>
					</Col>
					<Form.Label column className='col-auto'>
						Client Type
					</Form.Label>
					<Col className='col-auto client-list-filter case-list-filter me-15'>
						<Form.Select
							name='reportType'
							onChange={(e) => handleFieldChange(e)}
							className="w-auto report-dropdown"
						>
							<option value="CN" selected>Case list Diary (Client Wise)</option>
							<option value="CL">Case  List Diary</option>
						</Form.Select>
					</Col>
					<Form.Label column className='col-auto'>
						Status
					</Form.Label>
					<Col className='col-auto client-list-filter case-list-filter '>
						<Form.Select
							name='caseStatus'
							onChange={(e) => handleFieldChange(e)}
							className="w-auto report-dropdown"
						>
							<option value="" selected>ALL</option>
							<option value="ONGOING">ONGOING</option>
							<option value="WON">WON</option>
							<option value="LOST">LOST</option>
							<option value="CLOSED">CLOSED</option>
						</Form.Select>
					</Col>
					<Col className='col-auto next-date-button'>
						<Button className='generate-button' onClick={() => GenerateCaseListReportPDF()}>Generate Report</Button>
					</Col>
				</Row>
			</Form >
		</>
	)
}